import Accordion from 'devextreme-react/accordion';
import React, { useMemo, useState } from 'react';
import { BerthFItInformationParams } from '../../../../enums/berthfit-information-enum';
import Attachments from '../../attachments/Attachments';
import VesselHandledGrid from '../terminal-vessel-handled/TerminalVesselHandled';

export default function TerminalAccordion(props: {
  terminalCode: any;
  terminalId?: any;
  isFromViewInfoModal?: boolean;
  parameterInfo?: any[];
}) {
  const { terminalCode, isFromViewInfoModal, parameterInfo, terminalId } =
    props;
  const [selectedItems, setSelectedItems] = useState<any>([]);

  const accordionItems = useMemo(() => {
    return [
      {
        title: 'Vessel Handled',
        visible:
          !isFromViewInfoModal ||
          (isFromViewInfoModal &&
            parameterInfo?.includes(BerthFItInformationParams.VesselHandled)),
      },
      {
        title: 'Attachements',
        visible: !isFromViewInfoModal,
      },
    ];
  }, [parameterInfo]);

  const accordionItemRender = (e: any) => {
    switch (e.title) {
      case accordionItems[0].title: {
        return (
          <VesselHandledGrid
            terminalCode={terminalCode}
            isFromViewInfoModal={isFromViewInfoModal}
          />
        );
      }
      case accordionItems[1].title: {
        return (
          <Attachments
            isFromViewInfoModal={isFromViewInfoModal}
            terminalId={terminalId}
          />
        );
      }
    }
  };

  const selectionChanged = (e: any) => {
    let newItems: any = [...selectedItems];
    e.removedItems.map((item: any) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    setSelectedItems(newItems);
  };

  return (
    <div className="m-l-accordion-panel-body-block">
      <div className="m-l-accordion__main-section u-p0">
        <div className="m-c-accordion">
          <Accordion
            collapsible={true}
            multiple={true}
            items={accordionItems}
            itemRender={accordionItemRender}
            selectedItems={selectedItems}
            onSelectionChanged={selectionChanged}
          />
        </div>
      </div>
    </div>
  );
}
